import { useDimensions } from '@24i/nxg-sdk-quantum/src';
import { Breakpoint } from '../../utils/styles/constants';

export const useTopRowDimensions = () => {
    const { aspectRatio, width } = useDimensions();
    const isLandscape = width < Breakpoint.MD ? aspectRatio > 1 : true;

    return { isLandscape };
};
